import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import useListLimit from '@/hooks/useListLimit';
import { Arrow, Button } from '@winelidays/wld-tsx-2/elements';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import Dish from './Dish';
const DishList = t0 => {
    const $ = _c(19);
    const { type, dishes, appendTooltipTo } = t0;
    const translate = useTranslate();
    const t1 = `dish.dish_type.${type}`;
    let t2;
    if ($[0] !== t1 || $[1] !== translate) {
        t2 = capitalize(translate(t1, {
            number: 2
        }));
        $[0] = t1;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const title = t2;
    const { usesLimit, toggleLimited, limitedArray: limitedDishes, seeMoreLabel, arrowDirection } = useListLimit(dishes);
    let t3;
    if ($[3] !== dishes.length || $[4] !== translate) {
        t3 = dishes.length === 0 ? translate("dish.no_example") : null;
        $[3] = dishes.length;
        $[4] = translate;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    const noDish = t3;
    let t4;
    if ($[6] !== title) {
        t4 = <h3 className="mt-7 mb-6 text-lg font-bold">{title}</h3>;
        $[6] = title;
        $[7] = t4;
    }
    else {
        t4 = $[7];
    }
    let t5;
    if ($[8] !== appendTooltipTo || $[9] !== arrowDirection || $[10] !== limitedDishes || $[11] !== noDish || $[12] !== seeMoreLabel || $[13] !== toggleLimited || $[14] !== usesLimit) {
        t5 = noDish ? <p className="italic">{noDish}</p> : <><ul className="w-full">{limitedDishes.map(d => <Dish key={d.id} dish={d} appendTooltipTo={appendTooltipTo}/>)}</ul>{usesLimit && <Button onClick={toggleLimited} className="btn-ghost-primary w-full !text-base flex-shrink-0" title={seeMoreLabel}>{seeMoreLabel}<Arrow direction={arrowDirection} className="border-current border-2 w-3 h-3 ml-3"/></Button>}</>;
        $[8] = appendTooltipTo;
        $[9] = arrowDirection;
        $[10] = limitedDishes;
        $[11] = noDish;
        $[12] = seeMoreLabel;
        $[13] = toggleLimited;
        $[14] = usesLimit;
        $[15] = t5;
    }
    else {
        t5 = $[15];
    }
    let t6;
    if ($[16] !== t4 || $[17] !== t5) {
        t6 = <>{t4}{t5}</>;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    }
    else {
        t6 = $[18];
    }
    return t6;
};
export default DishList;
